import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export interface ReasoningData {
  competitors: string[];
  roomTypes: string[];
  currentOccupancy: number | null;
  pmsName: string | null;
  otas: string[];
  activeSeason: string | null;
  floorPrice: number | null;
  ceilingPrice: number | null;
  hotelName: string | null;
}

/**
 * Fetches personalized data for the AI Reasoning tab
 * Returns competitors, room types, PMS, OTAs, active season, pricing
 */
export function useReasoningData() {
  return useQuery<ReasoningData>({
    queryKey: ["ai-reasoning-data"],
    queryFn: () => api.aiReasoning.getData(),
    staleTime: 5 * 60 * 1000, // 5 minutes - data doesn't change frequently
  });
}
